// src/component/CategoryGrid.jsx
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { navigateToCategoryItem } from "../../helpers/categoryNavigator.js";

function CategoryIcon({ src, alt }) {
  // 화면 폭에 따라 3단계로 확대: 모바일 52 → sm(≥640px) 64 → md(≥768px) 80
  const sizeClass =
    "w-[52px] h-[52px] sm:w-[64px] sm:h-[64px] md:w-[80px] md:h-[80px]";
  if (!src) {
    return <div className={`${sizeClass} rounded-lg bg-bg-secondary border border-border-tertiary`} />;
  }
  return (
    <img src={src} alt={alt ?? "category"} className={`${sizeClass} object-contain`} loading="lazy" />
  );
}

export default function CategoryGrid({
  categories = [],
  title,
  mode = "navigate",
  selectedIds = [],
  onToggle,
}) {
  const navigate = useNavigate();

  // Server (dashboard/v1) returns the full home grid (service + manual entries)
  // already ordered by display_order. Qibla is dropped at the store boundary —
  // see service.store.setFromApi.
  const activeCategories = useMemo(
    () =>
      Array.isArray(categories)
        ? categories.filter((c) => c?.status !== false)
        : [],
    [categories],
  );

  const onClickItem = (item) => {
    if (mode === "toggle") {
      if (typeof onToggle === "function") onToggle(item.id);
      return;
    }
    // 라우팅 규칙은 CATEGORY 배너와 공유 — helpers/categoryNavigator.js 참조.
    navigateToCategoryItem(item, navigate);
  };

  if (!activeCategories.length) return null;

  return (
    <div className="mt-6">
      {title ? <p className="px-1 mb-2 text-heading-md">{title}</p> : null}

      <div className="flex flex-wrap gap-2">
        {activeCategories.map((item, index) => {
          const active = mode === "toggle" && selectedIds.includes(item.id);

          return (
            <button
              key={`${item.id}-${index}`}
              type="button"
              onClick={() => onClickItem(item)}
              className={[
                "w-[76px] sm:w-[88px] md:w-[100px] rounded-xl hover:bg-bg-secondary active:opacity-80",
                active ? "bg-bg-secondary ring-1 ring-black/20" : "",
              ].join(" ")}
            >
              <div className="flex flex-col items-center">
                <CategoryIcon src={item.image} alt={item.name} />

                <div className="h-2 sm:h-2.5 md:h-3" />

                <p
                  className="text-body-sm text-text-interactive-secondary text-center leading-4 line-clamp-2"
                  title={item.name}
                >
                  {item.name}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
